var _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-450 -589.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6032.5,3h-7a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.5.5Zm-.5-1V-4h-6V2Z",
    transform: "translate(6491 596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6032.5,3h-7a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.5.5Zm-.5-1V-4h-6V2Z",
    transform: "translate(6501 596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6032.5,3h-7a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.5.5Zm-.5-1V-4h-6V2Z",
    transform: "translate(6491 606.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6032.5,3h-7a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.5.5Zm-.5-1V-4h-6V2Z",
    transform: "translate(6501 606.001)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/GridView.6a2989dc9528e701f7ebadd0b4ffdcea.svg";
export { ForwardRef as ReactComponent };